import { Component, Inject, Input, OnInit } from "@angular/core";
import { DialogService } from "src/app/shared/components/dialog/service/dialog.service";
import { MobileComponent } from "src/app/shared/components/mobile/interface/mobile.component";
import { SubSink } from "subsink";
import { ChangeEmailComponent } from "../change-email/change-email.component";
import { ChangePasswordComponent } from "../change-password/change-password.component";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { MaterialModule } from "src/app/shared/module/material.module";
import { CommonModule } from "@angular/common";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "ald-manage-credentials",
    templateUrl: "./manage-credentials.component.html",
    styleUrls: ["./manage-credentials.component.scss"],
    imports: [
        I18nPipe,
        MaterialModule,
        I18nPipe,
        CommonModule
    ]
})
export class ManageCredentialsComponent
  extends MobileComponent
  implements OnInit {
  @Input() email: string;
  private subs = new SubSink();
  constructor(
    public dialogRef: MatDialogRef<ManageCredentialsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: DialogService
  ) {
    super();
    if (!!sessionStorage.getItem("email")) {
      this.email = sessionStorage.getItem("email");
    } else {
      this.email = !!this.email ? this.email : this.data;
    }
  }

  ngOnInit() { }

  onClose(): void {
    this.dialogRef.close();
  }

  onChangePasswordTrigger() {
    this.dialog
      .onOpenDialogResponsive(this.isMobile, ChangePasswordComponent, "")
      .subscribe((_) => console.log(_));
  }

  onChangeMailTrigger() {
    this.dialog
      .onOpenDialogResponsive(this.isMobile, ChangeEmailComponent, this.email)
      .subscribe((_) =>
        this.email = sessionStorage.getItem("email"));
  }
}
